import 'react';
import {Box, Stack, Typography} from '@mui/material';
import {InputField} from '@/pages/components/common';
import {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import type {V2Page} from '@/pages/components/audit-program/v-section/constants';
import {V2_PAGE} from '@/pages/components/audit-program/v-section/constants';
import ProgramSectionHeader from '@/pages/components/audit-program/a-section/ProgramSectionHeader';

export interface V2JournalWpViewProps {
    header: AuditProgramSectionVO;
    page: V2Page;
    refCode?: string;
    values: Record<string, string>;
    onChange: (key: string, value: string) => void;
}

const fieldSx = {minWidth: 0, width: '100%', maxWidth: '100%'};

/** V2 — Testing journal entries working paper (Q&A). */
export default function V2JournalWpView({
    header,
    page,
    refCode = 'V2',
    values,
    onChange,
}: V2JournalWpViewProps) {
    const meta = {
        title: page.title || V2_PAGE.title,
        intro: page.intro || V2_PAGE.intro,
        fields: page.fields?.length ? page.fields : V2_PAGE.fields,
    };

    return (
        <Box sx={{p: 2}}>
            <ProgramSectionHeader
                header={header}
                variant="a12"
                refCode={refCode}
                values={values}
                onChange={onChange}
            />

            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{textAlign: 'center', letterSpacing: 0.3, mb: 0.75, mt: 0.5}}
            >
                {meta.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{mb: 2, maxWidth: 820}}>
                {meta.intro}
            </Typography>

            <Stack spacing={1.5} sx={{maxWidth: 820}}>
                {meta.fields.map((f) => (
                    <Box key={f.id}>
                        <Typography variant="body2" fontWeight={600} sx={{mb: 0.5}}>
                            {f.label}
                        </Typography>
                        <InputField
                            type="text"
                            fullWidth
                            compact
                            multiline
                            minRows={2}
                            sx={fieldSx}
                            value={values[f.id] ?? ''}
                            onChange={(e) => onChange(f.id, e.target.value)}
                        />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
